import * as actionTypes from './actionTypes';
import axios from '../../global/axios';
import logger from '../../global/logger';


export const publishSlideshowSuccess = (details) => {
    return {
        type: actionTypes.PUBLISH_SLIDESHOW_SUCCESS,
        details: details
    }
};

export const publishSlideshowFailure = (error) => {
    return {
        type: actionTypes.PUBLISH_SLIDESHOW_FAILURE,
        error: error
    };
};

export const publishSlideshowStart = () => {
    return {
        type: actionTypes.PUBLISH_SLIDESHOW_START
    }
};

export const publishSlideshow = (slideshow_hash) => {
    return dispatch => {
        dispatch(publishSlideshowStart());
        
        let data = JSON.stringify({
                        hash: slideshow_hash
        })
        logger.log(data)
        axios.post('/slides/playlists/publish.json', data, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then(res => {
            // logger.log(res.data);
            dispatch(publishSlideshowSuccess(res.data));
        })
        .catch(err => {
            logger.log(err);
            dispatch(publishSlideshowFailure(err));
            alert(err.message);
        });
    }
}